import React, { useEffect, useState } from "react";
import "./GenericTable.css";
import {
  DataGrid,
  GridOverlay,
  GridSearchIcon,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import { genericTableType } from "../../features/editAndView/ViewAndEditType";
import { omit } from "lodash";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";

export const GenericTable = ({
  table,
  searchedProps,
  genericFilterProps,
}: genericTableType) => {
  const [rows, setRows] = useState(table.rows);
  const [searchedValue, setSeacrhedvalue] = useState("");
  const CUR_COMPONENT_COMMON="commonPortal";
  const { translate } = usePortalTranslation();

  useEffect(() => {
    setRows(table.rows);
  }, [table.rows]);

  const defaultFilter = (dataValue: string, searchedValue: string) => {
    if (!dataValue) {
      return;
    }
    dataValue = dataValue.toString();
    return dataValue.toLowerCase().includes(searchedValue.toLowerCase());
  };

  const filterData = (search: string) => {
    const newData = table.rows.filter((rowValue: any) => {
      const isPresent = searchedProps.filter(
        (searchedJson: { searchKey: string; searchFilter: any }) => {
          if (genericFilterProps) {
            return genericFilterProps(rowValue[searchedJson.searchKey], search);
          } else {
            return defaultFilter(rowValue[searchedJson.searchKey], search);
          }
        }
      );
      if (isPresent.length !== 0) {
        return true;
      } else {
        return false;
      }
    });
    setRows(newData);
  };

  const customNoRowsOverlay = () => (
    <GridOverlay>
      <div>{translate(TranslationEnum.common_portal,"No data available")}</div>
    </GridOverlay>
  );
  

  const CustomToolbar = ()=> {
    return (
      <GridToolbarContainer className="search-field">
        <input
          type="text"
          placeholder={translate(TranslationEnum.common_portal,"Search")}
          name="search"
          autoFocus
          className="search-input"
          value={searchedValue}
          onChange={(e) => {
            e.preventDefault();
            setSeacrhedvalue(e.target.value);
            filterData(e.target.value);
          }}
        />
        <GridSearchIcon className="search-icon" />
      </GridToolbarContainer>
    );
  };
  const tableAttributes = omit(table, ["rows", "columns"]);
  console.log("rows",rows,table.columns)
  return (
      <DataGrid
        rows={rows}
        columns={table.columns}
        // autoHeight={autoHeight}
        {...tableAttributes}
        className="datagrid-content"
        components={{
          Toolbar: tableAttributes.isOfflineSearchEnable && CustomToolbar,
          NoRowsOverlay: customNoRowsOverlay
        }}
        componentsProps={{
          pagination: {
            labelRowsPerPage: translate(TranslationEnum.common_portal,"Rows per page"),
          },
        }}
      />
  );
};
